





























import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
  },
})


export default class Download extends Vue {
  path = "assets/download/";

  bannerImgProportion = 802/1920;
  imgHeight= '';
  bannerImgSrc = require('@/'+this.path+"banner.png");

  //核心功能相关参数
  functionContent=[
    {name:"工单管理",src:require('@/'+this.path+"gongdan.png"),offset:2,
      text:"售后服务的核心引擎，多渠道客户报修、快速受理、智能派单，高效协同，多种模式支持公司的多业务发展"},
    {name:"设备管理",src:require('@/'+this.path+"shebei.png"),offset:1,
      text:"售后服务的重要资源，完善的设备信息，服务记录，通过预防维护及服务计划，确保设备稳健运行"},
    {name:"备件管理",src:require('@/'+this.path+"beijian.png"),offset:1,
      text:"有效的对仓库和备件进行管理，实时掌握备件流向，降低企业仓储成本"},
    {name:"客户管理",src:require('@/'+this.path+"kehu.png"),offset:2,
      text:"服务商档案、服务请求、服务进展、服务评价等"},
    {name:"统计分析",src:require('@/'+this.path+"tongji.png"),offset:1,
      text:"工单、备件、设备多维度数据分析，可视化决策"},
  ];

  mounted() {
    this.imgHeight = document.body.clientWidth * this.bannerImgProportion + 'px';
    let that = this;
    window.onresize = function windowResize() {
      // 通过捕获系统的onresize事件触发banner图高度自适应
      that.imgHeight = that.imgHeightChange(that.bannerImgProportion);
      console.log("aaa")
    }
  }

  imgHeightChange(proportion: number){
    var wid = document.body.clientWidth
    var hei = 826
    if (wid > 1920) {
      hei = 826
    } else {
      hei = proportion * wid
    }
    var height = hei + 'px';
    return height;
  }
}
